import React, { useState } from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { appData, getPortfolioText } from '../../../../data/portfolioData';
import './Projects.css';

// Importar las imágenes existentes del portfolio
import J0Image from '../../assets/J0.png';
import J1Image from '../../assets/J1.png';
import J2Image from '../../assets/J2.png';
import J3Image from '../../assets/J3.png';
import J4Image from '../../assets/J4.png';
import J5Image from '../../assets/J5.png';
import J6Image from '../../assets/J6.png';
import J7Image from '../../assets/J7.png';
import J8Image from '../../assets/J8.png';
import J9Image from '../../assets/J9.png';
import J10Image from '../../assets/J10.png';
import J11Image from '../../assets/J11.png';
import J12Image from '../../assets/J12.png';
import J13Image from '../../assets/J13.png';
import J14Image from '../../assets/J14.png';
import J15Image from '../../assets/J15.png';
import J16Image from '../../assets/J16.png';
import J17Image from '../../assets/J17.png';
import J18Image from '../../assets/J18.png';
import J19Image from '../../assets/J19.png';
import J20Image from '../../assets/J20.png';
import J21Image from '../../assets/J21.png';
import J22Image from '../../assets/J22.png';
import J23Image from '../../assets/J23.png';
import J24Image from '../../assets/J24.png';
import J25Image from '../../assets/J25.png';
import J26Image from '../../assets/J26.png';
import J27Image from '../../assets/J27.png';
import J28Image from '../../assets/J28.png';
import J29Image from '../../assets/J29.png';
import J30Image from '../../assets/J30.png';
import J31Image from '../../assets/J31.png';
import J32Image from '../../assets/J32.png';
import J33Image from '../../assets/J33.png';
import J34Image from '../../assets/J34.png';

const Projects = () => {
  const { getText, currentLanguage } = useLanguage();
  const [showAllProjects, setShowAllProjects] = useState(false);

  // Función para scroll suave a la sección de contacto
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Mapear las imágenes disponibles
  const imageMap = {
    'J0.png': J0Image,
    'J1.png': J1Image,
    'J2.png': J2Image,
    'J3.png': J3Image,
    'J4.png': J4Image,
    'J5.png': J5Image,
    'J6.png': J6Image,
    'J7.png': J7Image,
    'J8.png': J8Image,
    'J9.png': J9Image,
    'J10.png': J10Image,
    'J11.png': J11Image,
    'J12.png': J12Image,
    'J13.png': J13Image,
    'J14.png': J14Image,
    'J15.png': J15Image,
    'J16.png': J16Image,
    'J17.png': J17Image,
    'J18.png': J18Image,
    'J19.png': J19Image,
    'J20.png': J20Image,
    'J21.png': J21Image,
    'J22.png': J22Image,
    'J23.png': J23Image,
    'J24.png': J24Image,
    'J25.png': J25Image,
    'J26.png': J26Image,
    'J27.png': J27Image,
    'J28.png': J28Image,
    'J29.png': J29Image,
    'J30.png': J30Image,
    'J31.png': J31Image,
    'J32.png': J32Image,
    'J33.png': J33Image,
    'J34.png': J34Image
  };

  // Controlar cuántos proyectos mostrar
  const projectsToShow = showAllProjects ? appData.projects : appData.projects?.slice(0, 4);

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">{getText('portfolio.projects.title')}</span>
          <h2 className="section-title">{getText('portfolio.projects.subtitle')}</h2>
          <p className="section-description">
            {getText('portfolio.projects.subtitle')}
          </p>
        </div>

        <div className="projects-grid">
          {projectsToShow && projectsToShow.length > 0 ? projectsToShow.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img 
                  src={imageMap[project.image] || J0Image} 
                  alt={getPortfolioText(project.title, currentLanguage)}
                  loading="lazy"
                />
                <div className="project-overlay">
                  <div className="project-links">
                    {project.link && project.link !== '#' && (
                      <a 
                        href={project.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="project-link-btn"
                        title={getText('portfolio.projects.viewProject')}
                      >
                        👁️
                      </a>
                    )}
                    {project.github && project.github !== '#' && (
                      <a 
                        href={project.github} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="project-link-btn"
                        title={getText('portfolio.projects.viewCode')}
                      >
                        💻
                      </a>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="project-content">
                <div className="project-meta">
                  <span className="project-type">{getPortfolioText(project.type, currentLanguage)}</span>
                  <span className={`project-status ${getPortfolioText(project.status, currentLanguage).toLowerCase()}`}>
                    {getPortfolioText(project.status, currentLanguage)}
                  </span>
                </div>
                
                <h3 className="project-title">{getPortfolioText(project.title, currentLanguage)}</h3>
                <p className="project-description">
                  {getPortfolioText(project.description, currentLanguage)}
                </p>
                
                <div className="project-technologies">
                  {project.technologies && project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          )) : (
            <div>{getText('common.noResults')}</div>
          )}
        </div>

        {/* Botón para mostrar/ocultar más proyectos */}
        {appData.projects && appData.projects.length > 4 && (
          <div className="projects-toggle">
            <button 
              className="toggle-projects-btn"
              onClick={() => setShowAllProjects(!showAllProjects)}
            >
              {showAllProjects 
                ? getText('portfolio.projects.showLess') || 'Mostrar menos'
                : getText('portfolio.projects.showMore') || 'Ver todos los proyectos'
              }
              <span className={`toggle-arrow ${showAllProjects ? 'rotated' : ''}`}>
                ↓
              </span>
            </button>
          </div>
        )}

        <div className="projects-cta">
          <h3>{getText('portfolio.projects.ctaTitle') || '¿Tienes un proyecto en mente?'}</h3>
          <p>{getText('portfolio.projects.ctaDescription') || 'Me encantaría escuchar tu idea y ayudarte a hacerla realidad. ¡Trabajemos juntos!'}</p>
          <button onClick={scrollToContact} className="cta-button">
            {getText('portfolio.projects.contactButton') || 'Contactar'}
            <span className="cta-arrow">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
